export default "__VITE_PUBLIC_ASSET__50cbb222__"